module.exports = {
  token: {
    colorPrimary: '#000073',
    fontFamily: 'Inter var',
    colorBorder: '#efefff',
    colorText: '#000',
    fontSize: 16,
    lineHeight: 1.5715,
    colorPrimaryBorder: '#AA73F2',
    controlOutlineWidth: 0,
    colorLink: '#000073',
    colorLinkHover: '#000073',
    colorLinkActive: '#000073',
  },
  components: {
    Button: {
      colorPrimary: '#DBC5F8',
      colorTextLightSolid: '#000073',
      defaultColor: '#000073',
      defaultBg: '#ffffff',
      defaultBorderColor: '#AA73F2',
      defaultHoverBorderColor: '#AA73F2',
      fontWeight: 600,
      lineWidth: 2,
      primaryShadow: 'none',
      defaultShadow: 'none',
      paddingInline: 16,
      paddingInlineLG: 20,
    },
    Input: {
      hoverBorderColor: '#AA73F2',
    },
    Select: {
      optionSelectedBg: '#dbc5f8',
      optionSelectedColor: '#000073',
      optionActiveBg: '#dbc5f8',
      // Without these the Select border falls back to colorPrimary (#000073 navy) on hover/focus;
      // match Input.hoverBorderColor so the brand purple accent shows instead.
      hoverBorderColor: '#AA73F2',
      activeBorderColor: '#AA73F2',
    },
    Pagination: {
      itemActiveBg: '#F0E6FF',
    },
    DatePicker: {
      cellHoverBg: '#DBC5F8',
      cellHoverWithRangeBg: '#F5B9FE',
      cellRangeBorderColor: '#b7c7d4',
      cellActiveWithRangeBg: '#DBC5F8',
    },
    Layout: {
      bodyBg: '#f5f8ff',
    },
    Tooltip: {
      colorBgSpotlight: '#000073',
    },
    Radio: {
      buttonColor: '#000073',
      radioSize: 16,
    },
    Slider: {
      trackBg: '#495199',
      trackHoverBg: '#495199',
      handleColor: '#495199',
      handleActiveColor: '#495199',
      handleSize: 12,
      dotBorderColor: '#e9e9e9',
      dotActiveBorderColor: '#495199',
      railBg: '#f5f5f5',
      railHoverBg: '#f5f5f5',
    },
  }
};
